import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "input"]
    static values = {
        name: String
    }

    toggle(event) {
        event.preventDefault()
        this.formTarget.classList.toggle("hidden")

        if (!this.formTarget.classList.contains("hidden")) {
            if (this.hasInputTarget && this.hasNameValue) {
                const currentVal = this.inputTarget.value
                if (!currentVal.includes(`@${this.nameValue}`)) {
                    this.inputTarget.value = `@${this.nameValue}, ${currentVal}`
                }
            }
            if (this.hasInputTarget) {
                this.inputTarget.focus()
            }
        }
    }
}
